export const WORKSPACE_AGENT_COMPOSER_STOP_TOOLTIP_ENABLED = 'Stop the agent. Work in progress may finish first.';
export const WORKSPACE_AGENT_COMPOSER_STOP_TOOLTIP_LOADING = 'Stopping agent…';

export type GetWorkspaceAgentComposerStopTooltipParams = {
  isStopEnabled: boolean;
  isStopLoading: boolean;
};

/** Hover tooltip for the composer Stop button — enabled and loading states only. */
export const getWorkspaceAgentComposerStopTooltip = ({
  isStopEnabled,
  isStopLoading,
}: GetWorkspaceAgentComposerStopTooltipParams): string | undefined => {
  if (isStopLoading) {
    return WORKSPACE_AGENT_COMPOSER_STOP_TOOLTIP_LOADING;
  }

  if (isStopEnabled) {
    return WORKSPACE_AGENT_COMPOSER_STOP_TOOLTIP_ENABLED;
  }

  return undefined;
};
